<div class="dialog-container ta_center">
  <div class="dialog-body">
    <img [src]="imgSrc" [alt]="imgAltName" [class]="imgClass"/>
    <div class="title fw-600">{{ title }}</div>
    <div class="description fw-400">
      {{ description }}
    </div>
  </div>
  <div class="dialog-footer flex_sb">
    <button class="btn left-btn fw-600" (click)="handleLeftBtnClick()">
      {{ leftBtnText }}
    </button>
    <button class="btn right-btn fw-600" (click)="handleRightBtnClick()">
      {{ rightBtnText }}
    </button>
  </div>
</div>
